import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { toggleAddCreativeModal, toggleNameYourTemplateModal, toggleSelectTemplateModal } from '../../../../../../slices/modals/reducer';
import { Modal, ModalHeader, ModalBody, Row, Col, Card, CardHeader, CardBody, ModalFooter } from "reactstrap";
import DropFileTable from '../../../Components/DropFileTable';
import UploadCampaign from '../../../Components/UploadCampaign';
import SelectFromTemplate from '../EmptyPage/SelectFromTemplate';
import SelectedTemplatePage from '../EmptyPage/SelectedTemplatePage';
import { addTemplateCreative, getTemplate, getTemplateCategory, updateVersionStatusAfterUpdate } from '../../../../../../slices/campaigns/thunk';
import { setCampaignLoader, setFilteredTemplateCreatives, setSelectedTemplate, setTemplateCategories, setTemplateFilter, setTemplateLoader, setTemplates } from '../../../../../../slices/campaigns/reducer';
import NameYourTemplate from '../EmptyPage/NameYourTemplate';
import { setUploadedFiles } from '../../../../../../slices/uploads/reducer';
import VersionDetails from '../../../Components/VersionDetails';

function AddNewTemplateCreative({ dropFileType = {} }) {
  const dispatch = useDispatch();

  const selectAddCreativeModal = createSelector((state) => state.Modal, (state) => state.addCreativeModal);
  const addCreativeModal = useSelector(selectAddCreativeModal);

  const selectTemplateState = createSelector(state => state, state => ({
    selectedTemplate: state.Campaign.selectedTemplate,
    uploadedFiles: state.Upload.uploadedFiles,
    uploadLimits: state.Upload.uploadLimits
  }));
  const { selectedTemplate, uploadedFiles, uploadLimits } = useSelector(selectTemplateState);
  const [isSubmit, setIsSubmit] = useState(false);

  async function handleSubmit() {
    if (selectedTemplate === null) {
      dispatch(setCampaignLoader(true));
      dispatch(toggleNameYourTemplateModal());
      dispatch(setCampaignLoader(false));
    } else {
      dispatch(setCampaignLoader(true));
      await dispatch(addTemplateCreative());
      dispatch(updateVersionStatusAfterUpdate());
      dispatch(toggleAddCreativeModal());
      dispatch(setCampaignLoader(false));
    }
  }

  function returnEmptyPage() {
    dispatch(setUploadedFiles([]));
    dispatch(setSelectedTemplate(null))

  }

  async function changeTemplate() {
    dispatch(setTemplateCategories([]));
    dispatch(toggleSelectTemplateModal());
    dispatch(setTemplateLoader(true));
    await dispatch(getTemplate());
    await dispatch(getTemplateCategory());
    dispatch(setTemplateLoader(false));
  }

  function closeModal() {
    dispatch(toggleAddCreativeModal());
    setTimeout(() => {
      dispatch(setUploadedFiles([]));
      dispatch(setSelectedTemplate(null));
      dispatch(setTemplateCategories([]));
      dispatch(setTemplates(null));
      dispatch(setTemplateFilter({ query: null, campaignId: null }));
    }, 200);
  }

  useEffect(() => {
    if (Array.isArray(uploadedFiles) && uploadedFiles.length > 0) {
      dispatch(setFilteredTemplateCreatives(uploadedFiles));
    }
  }, [uploadedFiles]);

  return (
    <React.Fragment>
      <Modal isOpen={addCreativeModal} toggle={closeModal} centered size={selectedTemplate === null ? 'md' : "xl"}>
        <ModalHeader className='p-3' toggle={closeModal}>
          Add New
        </ModalHeader>
        <ModalBody className='px-3'>
          <Row>
            {selectedTemplate !== null ?
              <Col xxl={12} sm={12}>
                <Card className='d-flex flex-row p-3 align-items-center'>
                  <button className='btn btn-icon btn-light fw-bold me-2' onClick={returnEmptyPage}>
                    <i className='ri-arrow-left-line'></i>
                  </button>
                  <p className='m-0'>{selectedTemplate.name}</p>
                  <div className='d-flex ms-auto me-0'>
                    {/* <button className='btn btn-light me-1' onClick={editAllInFigmaPlugin}>
      <i className='mdi mdi-square-edit-outline align-bottom me-1'></i>
      Edit All Creatives In Figma Plugin
    </button> */}
                    <button className='btn btn-soft-primary' onClick={changeTemplate}>Change Template</button>
                  </div>
                </Card>
              </Col>
              : null}
          </Row>
          <Row>
            <Col xl={12} lg={12} md={12} sm={12} className='mb-3'>
              <VersionDetails showOnlyFilter={true} />
            </Col>
            {selectedTemplate !== null ?
              <Col>
                <SelectedTemplatePage />
              </Col>
              :
              <>
                {uploadedFiles?.length === 0 ?
                  <Col xl={12} lg={12} md={12} sm={12} >
                    <SelectFromTemplate />
                  </Col>
                  : null}
                {/* <Col xl={uploadedFiles?.length === 0 ? 6 : 12} lg={uploadedFiles?.length === 0 ? 6 : 12} md={12} sm={12}>
                  <Card style={{ minHeight: "330px" }}>
                    <CardHeader>Upload HTML</CardHeader>
                    <CardBody>
                      <UploadCampaign limits={dropFileType} />
                      <DropFileTable />
                    </CardBody>
                  </Card>
                </Col> */}
              </>
            }
          </Row>
        </ModalBody>
        <ModalFooter>
          <button className='btn btn-light' type='button' onClick={closeModal}>Close</button>
          <button className='btn btn-success' type='button' onClick={handleSubmit}>Save</button>
        </ModalFooter>
      </Modal>
      <NameYourTemplate setIsSubmit={setIsSubmit} />
    </React.Fragment>
  )
}

export default AddNewTemplateCreative;